import React, { useEffect, useRef, useState } from "react";
import { Collapse } from "antd";
import { Popover } from "antd";
import { debounce } from "lodash";
import LOGO from "@/assets/images/logo.svg";
// import VIDEO_IMG from'../video_img.jpg';
import { usePostHog } from 'posthog-js/react';
import { detectDevice } from '@/utils'
import { MAC_DOWNLOAD, WIN_DOWNLOAD } from '@/config/constent';
import { recordEventRecord } from '@/apis/record';
import './index.scss'

interface Props {

}

const VIDEO_IMG = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/4.jpg'

// const MAC_DOWNLOAD =
// "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28MacOS%29.zip";
// const WIN_DOWNLOAD =
//   "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28Windows%29.zip";
const TEACH_URL =
"https://mi8elatzm1x.feishu.cn/wiki/SfaxwB67JiEoHAkvpf1cVUfInVf?from=from_copylink";

const BROARD_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/OxyTw5WjqiqhgykN6bHcJZtxnRg?table=tblW4jUgv0eRYdSS&view=vewi8cd7P3'
const xiaohongshu_link = 'https://www.xiaohongshu.com/user/profile/63070886000000000f005dba';
const bilibili_link = 'https://space.bilibili.com/3546687805065289'
const douyin_link = 'https://v.douyin.com/JZSjiobaTis/%201@2.com'

const Download: React.FC<Props> = (props: Props) => {
    const posthog = usePostHog();
    const isPc = detectDevice()

    const searchParamsString = window.location.href.split('?')[1] || '';
    const searchParams = new URLSearchParams(searchParamsString);
    const source = searchParams.get('s'); // source 参数值
    const detail = searchParams.get('d'); // detail 参数值  

    const macRef = useRef<HTMLAnchorElement | null>(null);
    const winRef = useRef<HTMLAnchorElement | null>(null);
  
    const handleMACDownload = debounce(() => {
      if (macRef.current) {
        macRef.current?.click();
        if (source && detail) {
            recordEventRecord({
                event_name: 'haohui_source_download',
                source: source,
                event_id: detail,
                tag: {
                  type: 'mac',
                }
            })
            // posthog?.capture('haohui_source_download', {
            //   source: source,
            //   detail: detail,
            //   type: 'mac'
            // });
        }
        recordEventRecord({
            event_name: 'haohui_download',
            tag: {
              type: 'mac',
            }
          })
        // posthog?.capture('haohui_download', {
        //     type: 'mac',
        //     info: navigator?.userAgent
        //   });
      }
    }, 1000);
  
    const handleWINDownload = debounce(() => {
      if (winRef.current) {
        winRef.current?.click();
        if (source && detail) {
            recordEventRecord({
                event_name: 'haohui_source_download',
                source: source,
                event_id: detail,
                tag: { 
                    type: 'win',    
                }    
            })
            // posthog?.capture('haohui_source_download', {
            //   source: source,
            //   detail: detail,
            //   type: 'win'
            // });
        }
        recordEventRecord({
            event_name: 'haohui_download',
            tag: {
              type: 'win',
            }
          })
        // posthog?.capture('haohui_download', {
        //     type: 'win',
        //     info: navigator?.userAgent
        //   });
      }
    }, 1000);

    const items = [
        {
          key: '1',
          label: '帮助',
          children: (
            <>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ lineHeight: '2.5em', fontSize: '1em' }}><a className="menu-item" href={TEACH_URL} target="_blank">使用教程</a></div>
                    <div style={{ lineHeight: '2.5em', fontSize: '1em' }}><a className="menu-item" href={BROARD_LINK} target="_blank">案例广场</a></div>
                    <Popover
                        getPopupContainer={(trigger: any) => trigger.parentElement}
                        content={<img style={{ width: 'auto', height: '300px' }} src={VIDEO_IMG} alt="video" />}
                        placement="topLeft"
                        color="#191824"
                        arrow={false}
                        // open={true}
                    >
                        <div style={{ lineHeight: '2.5em', fontSize: '1em' }}>
                            <span className="menu-item">线上直播课</span>
                        </div>
                        
                    </Popover>
                </div>
            </>
          ),
        },
        {
          key: '2',
          label: '关注我们',
          children: (
            <>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ lineHeight: '2.5em', fontSize: '1em' }}>
                        <a className="menu-item" href={xiaohongshu_link} target="_blank">小红书</a>
                    </div>
                    <div style={{ lineHeight: '2.5em', fontSize: '1em' }}>
                        <a className="menu-item" href={bilibili_link} target="_blank">bilibili</a>
                    </div>
                    <div style={{ lineHeight: '2.5em', fontSize: '1em' }}>
                        <a className="menu-item" href={douyin_link} target="_blank">抖音</a>
                    </div>

                    <Popover
                        getPopupContainer={(trigger: any) => trigger.parentElement}
                        content={<img style={{ width: 'auto', height: '300px' }} src={VIDEO_IMG} alt="video" />}
                        placement="topLeft"
                        color="#191824"
                        arrow={false}
                        // open={true}
                    >
                         <div style={{ lineHeight: '2.5em', fontSize: '1em' }}>
                            <span className="menu-item">视频号</span>
                        </div>
                    </Popover>
                </div>
            </>
          ),
        },

      ];

    return (
        <div className="main-content" style={isPc ? {} : { flexDirection: 'column', padding: '2em 0em 2em 0em' }}>
            {/* <div className="theme-section">
                <div className="theme-title">
                    <img style={{ width: '88px', height: 'auto', marginRight: '4px'}} src={LOGO} alt="logo" />
                    <span>森宇宙</span>
                </div>
                <div className="theme-second-title">森宇宙好绘AI</div>
            </div> */}
            {
                isPc 
                    ? (
                        <>
                        <div className="download-section">
                            <div className="section-title">立即下载</div>
                            <span className="menu-item" onClick={handleWINDownload}>下载Windows版本</span>
                            <span className="menu-item" onClick={handleMACDownload}>下载Mac OS版本</span>
                            <a
                                ref={macRef}
                                href={MAC_DOWNLOAD}
                                style={{ visibility: "hidden" }}
                            >
                                {" "}
                            </a>
                            <a
                                ref={winRef}
                                href={WIN_DOWNLOAD}
                                style={{ visibility: "hidden" }}
                            >
                                {" "}
                            </a>
                        </div>         
                        <div className="help-section">
                            <div className="section-title">帮助</div>
                            <a className="menu-item" href={TEACH_URL} target="_blank">使用教程</a>
                            <a className="menu-item" href={BROARD_LINK} target="_blank">案例广场</a>
                            <Popover
                                getPopupContainer={(trigger: any) => trigger.parentElement}
                                content={<img style={{ width: 'auto', height: '300px' }} src={VIDEO_IMG} alt="video" />}
                                placement="right"
                                color="#191824"
                                arrow={false}
                                // open={true}
                            >
                                <span className="menu-item">线上直播课</span>
                            </Popover>
                        </div>
                        <div className="help-section">
                            <div className="section-title">关注我们</div>
                            <a className="menu-item" href={xiaohongshu_link} target="_blank">小红书</a>
                            <a className="menu-item" href={bilibili_link} target="_blank">bilibili</a>
                            <a className="menu-item" href={douyin_link} target="_blank">抖音</a>
                            <Popover
                                getPopupContainer={(trigger: any) => trigger.parentElement}
                                content={<img style={{ width: 'auto', height: '300px' }} src={VIDEO_IMG} alt="video" />}
                                placement="right"
                                color="#191824"
                                arrow={false}
                                // open={true}
                            >
                                <span className="menu-item">视频号</span>
                            </Popover>
                        </div>
                        </>
                    )
                    : (
                        <div className="main-content-panel">
                            <Collapse 
                            expandIconPosition="end" bordered={false} accordion 
                            items={items} />
                        </div>
                    )
            }
            

        </div>
    )
}

export default Download;